module.exports = __webpack_public_path__ + "img/imagen_parrafo_1.4b1536e7.png";